import React, { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./finishedScreen.css";
import { useTranslation } from "react-i18next";

const CompletionScreen = ({ lesson, onRepeat }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const confettiRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    // Confetti animation
    const COLORS = ['#7C3AED','#A78BFA','#F97316','#FCD34D','#34D399','#F472B6','#60A5FA','#FBBF24'];
    
    const makeConfetti = () => {
      const container = confettiRef.current;
      if (!container) return;
      
      for (let i = 0; i < 80; i++) {
        const el = document.createElement('div');
        el.className = 'confetti-piece';
        el.style.cssText = `
          left: ${Math.random() * 100}%;
          background: ${COLORS[Math.floor(Math.random() * COLORS.length)]};
          animation-duration: ${2 + Math.random() * 2.5}s;
          animation-delay: ${Math.random() * 1.5}s;
          width: ${6 + Math.random() * 8}px;
          height: ${8 + Math.random() * 12}px;
          border-radius: ${Math.random() > 0.5 ? '50%' : '2px'};
          transform: rotate(${Math.random()*360}deg);
        `;
        container.appendChild(el);
        el.addEventListener('animationend', () => el.remove());
      }
    };
    
    makeConfetti();
    const timeout = setTimeout(makeConfetti, 1600);
    
    return () => clearTimeout(timeout);
  }, []);

  const handleNextLesson = () => {
    const currentId = parseInt(id);
    const nextId = currentId + 1;
    navigate(`/lesson/${nextId}`);
    window.location.reload();
  };

  const handleRepeatLesson = () => {
    if (onRepeat) {
      onRepeat();
    }
  };

  return (
    <>
      <div className="confetti-container" ref={confettiRef}></div>

      <div className="success-card">
      <div className="success-top">
        <div className="trophy-wrap">
          <div className="sparkles">
            <div className="sparkle"></div>
            <div className="sparkle"></div>
            <div className="sparkle"></div>
            <div className="sparkle"></div>
          </div>
          <div className="trophy-bg">🏆</div>
        </div>

        <div className="success-label">{t("Lesson completed")}</div>
        </div>

        <h1 className="success-title">
         {t("Great! Lesson")}<br />
          <span>«{lesson?.video?.name || 'Lesson'}»</span><br />
           {t("completed!")}
        </h1>
        <p className="success-subtitle">
          {t("You\'ve completed the dialogue practice for this video. You can now move on to the next lesson or review this one again.")}
        </p>

        <div className="btn-row">
          <button className="btn-primary" onClick={handleNextLesson}>
            {t("Next Lesson")} <span className="arrow">→</span>
          </button>
          <button className="btn-secondary" onClick={handleRepeatLesson}>
            {t("Repeat Lesson")}
          </button>
        </div>
      </div>
    </>
  );
};

export default CompletionScreen;
